/**
 * Hook to intercept external link clicks and open them in default browser
 * Only active when running in Tauri desktop app
 */


import { useEffect } from 'react';
import { isTauri, isExternalUrl, openExternal } from '@/lib/utils/tauri';

export function useExternalLinks() {
  useEffect(() => {
    // Only run in Tauri
    if (!isTauri()) return;

    const handleClick = async (event: MouseEvent) => {
      // Find the closest anchor element
      const target = event.target as HTMLElement;
      const anchor = target.closest('a');

      if (!anchor) return;

      const href = anchor.getAttribute('href');
      if (!href) return;

      // Don't intercept download links - let browser handle them
      if (anchor.hasAttribute('download')) {
        return;
      }

      // Don't intercept links with target="_blank" that are blob URLs (downloads)
      if (href.startsWith('blob:')) {
        return;
      }

      // Check if it's an external URL
      if (isExternalUrl(href)) {
        event.preventDefault();
        event.stopPropagation();
        await openExternal(href);
      }
    };

    // Add click listener to document
    document.addEventListener('click', handleClick, true);

    return () => {
      document.removeEventListener('click', handleClick, true);
    };
  }, []);
}

export default useExternalLinks;
